// Link único dos CTAs públicos do site para o número de contingência YCloud.
// A atribuição acontece no backend; nenhum identificador aparece na mensagem.

export const WHATSAPP_PHONE = '5519988332466';

export const SITE_CTA_MESSAGE = 'Olá, gostaria de criar uma música personalizada';

/**
 * Monta a URL wa.me com a mensagem de origem-site.
 * @param _ref mantido por compatibilidade. A origem deve chegar ao site por UTM;
 *             ela nunca é anexada à mensagem enviada pelo cliente.
 */
export function buildWhatsAppCtaUrl(_ref?: string): string {
  return `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(SITE_CTA_MESSAGE)}`;
}

/** URL pronta pro caso mais comum (sem afiliado). */
export const WHATSAPP_CTA_URL = buildWhatsAppCtaUrl();
